module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"error-404-title":"Oups!","error-404-subtitle":"Page introuvable","error-404-text":"La page que vous tentez d\u0027afficher n\u0027est plus disponible.","error-404-return":"Retour à l\u0027accueil"},"en":{"error-404-title":"Oups !","error-404-subtitle":"Page not found","error-404-text":"The page you requested is no longer available.","error-404-return":"Return to home page"}}')
  delete Component.options._Ctor
}
